import { ROLES } from "@habity/constants";

type UserWithRole = {
  roles?: string[] | null;
  role?: string | null;
};

/**
 * Get user roles from the user object
 * Uses the roles array from user_roles relation
 */
const getUserRoles = (user?: UserWithRole | null): string[] => {
  if (user?.roles && Array.isArray(user.roles)) {
    return user.roles;
  }
  return [];
};

/**
 * Check if a user has the admin role
 * Works with both raw database rows and nested user types
 */
export const isAdmin = (user?: UserWithRole | null): boolean => {
  return getUserRoles(user).includes(ROLES.ADMIN);
};

/**
 * Check if a user has the broker role
 * Works with both raw database rows and nested user types
 */
export const isBroker = (user?: UserWithRole | null): boolean => {
  return getUserRoles(user).includes(ROLES.BROKER);
};

/**
 * Check if a user has the broker or admin role
 * Works with both raw database rows and nested user types
 */
export const isBrokerOrAdmin = (user?: UserWithRole | null): boolean => {
  return isBroker(user) || isAdmin(user);
};
